import { call, put, select, takeEvery, takeLatest } from "redux-saga/effects"

import { GET_USER_ACTIVITY, GET_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY, UPDATE_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY } from "./actionTypes"

import {
    getUserActivitySuccess,
    getUserActivityError,
    getAdminUserColumnPreferenceUserActivitySuccess,
    getAdminUserColumnPreferenceUserActivityError,
    updateAdminUserColumnPreferenceUserActivitySuccess,
    updateAdminUserColumnPreferenceUserActivityError
} from "./actions"

import {
    genericGetRequest, genericGetRequest_2, genericPutRequest
} from "../../helpers/sf_backend_helper"

import { AppConfiguration } from "config"
import { bsh_getAdminUserDetails } from "helpers/sf_browser_storage_helper"
import { buildPaginationCacheKey } from "helpers/sf_utils"

const inFlightUserActivityRequests = new Set()

function* onGetUserActivity(action) {
    try {
        const useCache = Boolean(action.payload?.useCache)
        const queryParams = action.payload?.queryParams || {}
        const requestedPageNumber = parseInt(queryParams.page_number, 10) || 1
        const cacheKey = useCache ? buildPaginationCacheKey(queryParams) : null
        const requestKey = `${cacheKey}:${requestedPageNumber}`
        const cachedPage = useCache
            ? yield select((state) => state.AdminUserActivity.page_cache?.[cacheKey]?.[requestedPageNumber])
            : null

        if (useCache && cachedPage) {
            return
        }

        if (useCache && inFlightUserActivityRequests.has(requestKey)) {
            return
        }

        if (useCache) {
            inFlightUserActivityRequests.add(requestKey)
        }

        let user = bsh_getAdminUserDetails();
        const response = yield call(
            genericGetRequest_2,
            `${AppConfiguration.BACKEND_URL}/api/v1/admin_user_activity`,
            queryParams,
            {
                Authorization: user.token,
            }
        )
        yield put(getUserActivitySuccess(response, {
            appendResults: Boolean(action.payload?.appendResults),
            queryParams,
            useCache,
        }))
    } catch (error) {
        yield put(getUserActivityError(error))
    } finally {
        if (action.payload?.useCache) {
            const queryParams = action.payload?.queryParams || {}
            const requestedPageNumber = parseInt(queryParams.page_number, 10) || 1
            const cacheKey = buildPaginationCacheKey(queryParams)
            inFlightUserActivityRequests.delete(`${cacheKey}:${requestedPageNumber}`)
        }
    }
}

function* onGetAdminUserColumnPreferenceUserActivity(action) {
    try {
        let user = bsh_getAdminUserDetails();
        const response = yield call(
            genericGetRequest,
            `${AppConfiguration.BACKEND_URL}/api/v1/admin_user_col_pref_user_activity`,
            action.payload?.queryParams,
            {
                Authorization: user.token,
            }
        )
        yield put(getAdminUserColumnPreferenceUserActivitySuccess(response))
    } catch (error) {
        yield put(getAdminUserColumnPreferenceUserActivityError(error))
    }
}

function* onUpdateAdminUserColumnPreferenceUserActivity(action) {
    try {
        let user = bsh_getAdminUserDetails();
        const response = yield call(
            genericPutRequest,
            `${AppConfiguration.BACKEND_URL}/api/v1/admin_user_col_pref_user_activity/${action.payload?.admin_user_col_pref_user_activity?.id}`,
            {
                body: JSON.stringify({
                    ...action.payload,
                }),
                headers: {
                    Authorization: user.token,
                    'Content-Type': 'application/json'
                }
            }
        )
        yield put(updateAdminUserColumnPreferenceUserActivitySuccess(response))
    } catch (error) {
        yield put(updateAdminUserColumnPreferenceUserActivityError(error))
    }
}

function* AdminUserActivitySaga() {
    yield takeLatest(GET_USER_ACTIVITY, onGetUserActivity)
    yield takeEvery(GET_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY, onGetAdminUserColumnPreferenceUserActivity)
    yield takeEvery(UPDATE_ADMIN_USER_COLUMN_PREFERENCE_USER_ACTIVITY, onUpdateAdminUserColumnPreferenceUserActivity)
}

export default AdminUserActivitySaga
